function toggleCart() {
  document.getElementById('cartSidebar').classList.toggle('open');
  document.getElementById('cartOverlay').classList.toggle('open');
}

function addToCart(variantId, btn) {
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
    updateCartDrawer();
    showToast('🌿 Added to cart!');
    document.getElementById('cartSidebar').classList.add('open');
    document.getElementById('cartOverlay').classList.add('open');
  })
  .catch(() => {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
  });
}

function updateCart(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => updateCartDrawer());
}

function updateCartDrawer() {
  fetch('/cart.js')
  .then(r => r.json())
  .then(cart => {
    const itemsEl = document.getElementById('cartItems');
    const countEl = document.getElementById('cartCount');
    const footer = document.querySelector('.cart-footer');
    if (countEl) countEl.textContent = cart.item_count;
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="empty-cart"><div class="empty-cart-icon">🌿</div><p>Your cart is empty.<br>Discover our natural oils!</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    let html = '';
    cart.items.forEach(item => {
      html += `<div class="cart-item">
        <div class="cart-item-img">${item.image ? `<img src="${item.image}" alt="${item.title}">` : '🫒'}</div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.title}</div>
          <div class="cart-item-price">$${(item.final_line_price/100).toFixed(2)}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity-1})">−</button>
            <span class="qty-val">${item.quantity}</span>
            <button class="qty-btn" onclick="updateCart('${item.key}', ${item.quantity+1})">+</button>
          </div>
          <button class="cart-remove" onclick="updateCart('${item.key}', 0)">Remove</button>
        </div>
      </div>`;
    });
    itemsEl.innerHTML = html;
    if (footer) {
      footer.style.display = 'block';
      footer.innerHTML = `
        <div class="cart-total"><span>Total (inc. GST)</span><span>$${(cart.total_price/100).toFixed(2)}</span></div>
        <a href="/checkout" class="checkout-btn">Proceed to Checkout →</a>`;
    }
  });
}

let toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
}

function subscribeNewsletter() {
  const email = document.getElementById('emailInput');
  if (email && email.value) {
    showToast('🎉 Welcome! Use code WELCOME10 for 10% off!');
    email.value = '';
  } else {
    showToast('Please enter your email address.');
  }
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.product-card, .benefit-card, .review-card').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  observer.observe(el);
});
